class Storage {
  async save(key: string, data: any): Promise<void> {
    return localStorage.setItem(key, JSON.stringify(data))
  }

  async load(key: string, defaultValue: any = undefined): Promise<any | undefined> {
    const data = localStorage.getItem(key)
    if (!data) return defaultValue

    try {
      return JSON.parse(data)
    } catch (error) {
      localStorage.removeItem(key)
      return defaultValue
    }
  }

  async remove(key: string): Promise<void> {
    return localStorage.removeItem(key)
  }

  async purgeAllData(): Promise<void> {
    return localStorage.clear()
  }
}

export default new Storage()
